import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  setArea,
  setQuickSearchFlg,
  setQuickSearchResultFlg,
  setCompanyInfo,
} from '../../actions/CompanyAction';
import {
  getAreaMaster,
  setInitMessage,
  getContractLabel,
  setContractLabel,
  getDispItem,
} from '../../actions/CommonAction';
import CompanyDownloadStatusComponent from './CompanyDownloadStatusComponent';
import CompanyTreeListComponent from './CompanyTreeListComponent';
import CompanyDownloadComponent from './CompanyDownloadComponent';
import CompanyInfoComponent from './CompanyInfoComponent';
import CompanyAdditionalItemListComponent from './CompanyAdditionalItemListComponent';
import './CompanyComponent.css';

class CompanyComponent extends Component {
  async componentDidMount() {
    // Google Analytics
    window.gtagPageview();

    const {
      area,
      getAreaMasterAct,
      setAreaAct,
      getContractLabelAct,
      setContractLabelAct,
      getDispItemAct,
      setCompanyInfoAct,
      companyInfo,
    } = this.props;
    if (!area) {
      // 地域マスタ情報取得
      const ret = await getAreaMasterAct();
      if (ret && ret.area_list) {
        // 地域マスタ情報を一時保存領域に保持
        setAreaAct(ret.area_list);
      }
    }
    // 契約ラベルマスタ取得
    const contlactLabel = await getContractLabelAct();
    setContractLabelAct(contlactLabel);

    // 表示項目マスタ取得
    if (!companyInfo.display_list) {
      const resDispItem = await getDispItemAct();
      setCompanyInfoAct(resDispItem);
    }
  }

  componentWillUnmount() {
    const {
      setInitMessageAct,
      setQuickSearchFlgAct,
      setQuickSearchResultFlgAct,
    } = this.props;
    setQuickSearchFlgAct(false);
    setQuickSearchResultFlgAct(false);
    setInitMessageAct();
  }

  render() {
    return (
      <div className="searchcompany">
        <div className="container">
          <div className="container1">
            {/* 階層情報（企業階層、出資率50%超、地域階層） */}
            {/* 階層情報ツリー */}
            <CompanyTreeListComponent />
          </div>
          <div className="container2">
            {/* ダウンロードステータス */}
            <CompanyDownloadStatusComponent />
            {/* 企業情報（拠点情報、企業情報） */}
            <CompanyInfoComponent />
          </div>
        </div>
        {/* ファイルダウンロードポップアップ */}
        <CompanyDownloadComponent />
        {/* 取引情報一覧ポップアップ */}
        <CompanyAdditionalItemListComponent />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    areaList: state.company.areaList,
    contractLabel: state.common.contractLabel,
    // 企業情報（拠点情報、企業情報）
    companyInfo: state.company.companyInfo,
  }),
  (dispatch) => ({
    setAreaAct: (obj) => dispatch(setArea(obj)),
    getAreaMasterAct: () => dispatch(getAreaMaster()),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setQuickSearchFlgAct: (flg) => dispatch(setQuickSearchFlg(flg)),
    setQuickSearchResultFlgAct: (flg) => dispatch(setQuickSearchResultFlg(flg)),
    getContractLabelAct: () => dispatch(getContractLabel()),
    setContractLabelAct: (object) => dispatch(setContractLabel(object)),
    getDispItemAct: () => dispatch(getDispItem()),
    setCompanyInfoAct: (object) => dispatch(setCompanyInfo(object)),
  }),
)(CompanyComponent);
